var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28278 17.0632C8.98113 8.42299 12.7719 3.51548 16.7348 1.03825C17.331 0.665566 18.07 1.2763 18.0341 1.97849C17.7083 8.36406 25.1728 16.731 26.4135 19.3521C30.9579 28.953 20.7616 34.1268 15.9254 34.8735C-5.48466 37.9138 -0.0866699 13.9701 3.33975 12.7915C5.36773 12.094 6.35625 15.9855 7.68011 17.3545C7.91616 17.5985 8.25542 17.4016 8.28278 17.0632Z",
    fill: "#F0BF41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22949 34.2925C2.78611 32.5154 3.07728 28.279 3.78492 24.0273C3.88363 23.4342 4.49021 23.0719 5.07171 23.2248C14.2877 25.6483 10.9926 18.8856 15.694 16.5352C18.5428 15.1109 26.5505 26.0099 22.6941 32.073C22.6877 32.0831 22.6804 32.0926 22.6722 32.1013C19.7353 35.2344 11.289 35.9161 7.22949 34.2925Z",
    fill: "#F7D16F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.77bb4807ddcf449c8308959dcd1fc785.svg";
export { ForwardRef as ReactComponent };